import { OpiTriggerItem } from '../../interface/opi-trigger';

export class OpiTriggerEmptyResponseDto { }

export class OpiTriggerResponseDto {
  /** Pre-authorization trigger as a root trigger */
  preauth: {
    /** Primary Key of the trigger */
    id: number;
    /** Payment Provider ID issued by Payment Service Provider (Ie AIB) */
    refId: string | null;
    /** Type of the trigger */
    type: 'preauth';
    /** Properties of the trigger */
    props: {
      /** Items of the trigger */
      items: OpiTriggerItem[];
      /** Total amount of the trigger */
      total: number;
      /** Currency code. */
      currency: string;
    };
  };
  /** Array of topup triggers. Empty if no topup triggers. */
  topups: {
    /** Primary Key of the trigger */
    id: number;
    /** Payment Provider ID issued by Payment Service Provider (Ie AIB) */
    refId: string | null;
    /** Type of the trigger */
    type: 'topup';
    /** Properties of the trigger */
    props: {
      /** Items of the trigger */
      items: OpiTriggerItem[];
      /** Total amount of the trigger */
      total: number;
      /** Currency code. */
      currency: string;
    };
  }[];
  /** Release trigger `checkout` or `release`. Null if the transactions is not completed. */
  final: {
    /** Primary Key of the trigger */
    id: number;
    /** Payment Provider by Payment Service Provider (Ie AIB) */
    refId: string | null;
    /** Type of the trigger */
    type: 'checkout' | 'release';
    /** Properties of the trigger */
    props: {
      /** Items of the trigger */
      items: OpiTriggerItem[];
      /** Total amount of the trigger */
      total: number;
      /** Currency code. */
      currency: string;
    };
  } | null;

  constructor() {
    this.preauth = null;
    this.topups = [];
    this.final = null;
  }
}
